import { render } from "./BookingRules.vue?vue&type=template&id=306c6938&scoped=true"
import script from "./BookingRules.vue?vue&type=script&lang=js"
export * from "./BookingRules.vue?vue&type=script&lang=js"

import "./BookingRules.vue?vue&type=style&index=0&id=306c6938&scoped=true&lang=css"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306c6938"]])

export default __exports__